// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

var defaultHeadlessApplePayToken_paymentRequestData = null;

var defaultHeadlessApplePayToken = {
  paymentRequestData: defaultHeadlessApplePayToken_paymentRequestData,
  sessionTokenData: undefined
};

function getTotal(totalDict) {
  if (Utils$OrcaPaymentPage.getString(totalDict, "type", "") === "") {
    return {
            label: Utils$OrcaPaymentPage.getString(totalDict, "label", ""),
            amount: Utils$OrcaPaymentPage.getString(totalDict, "amount", "")
          };
  } else {
    return {
            label: Utils$OrcaPaymentPage.getString(totalDict, "label", ""),
            type: Utils$OrcaPaymentPage.getString(totalDict, "type", ""),
            amount: Utils$OrcaPaymentPage.getString(totalDict, "amount", "")
          };
  }
}

function jsonToPaymentRequestDataType(jsonDict) {
  var merchantIdentifier = Utils$OrcaPaymentPage.getString(jsonDict, "merchant_identifier", "");
  var applePayLaterAvailability = Utils$OrcaPaymentPage.getString(jsonDict, "apple_pay_later_availability", "");
  var recurring = jsonDict["recurring_payment_request"];
  var deferred = jsonDict["deferred_payment_request"];
  var autoReload = jsonDict["automatic_reload_payment_request"];
  var requiredBilling = Utils$OrcaPaymentPage.getStrArray(jsonDict, "required_billing_contact_fields");
  var requiredShipping = Utils$OrcaPaymentPage.getStrArray(jsonDict, "required_shipping_contact_fields");
  var supportedCountries = Utils$OrcaPaymentPage.getStrArray(jsonDict, "supported_countries");
  var tmp = {
    countryCode: Utils$OrcaPaymentPage.getString(jsonDict, "country_code", Utils$OrcaPaymentPage.defaultCountryCode),
    currencyCode: Utils$OrcaPaymentPage.getString(jsonDict, "currency_code", ""),
    total: getTotal(Utils$OrcaPaymentPage.getDictFromObj(jsonDict, "total")),
    merchantCapabilities: Utils$OrcaPaymentPage.getStrArray(jsonDict, "merchant_capabilities"),
    supportedNetworks: Utils$OrcaPaymentPage.getStrArray(jsonDict, "supported_networks")
  };
  var tmp$1 = merchantIdentifier === "" ? undefined : merchantIdentifier;
  if (tmp$1 !== undefined) {
    tmp.merchantIdentifier = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = applePayLaterAvailability === "" ? undefined : applePayLaterAvailability;
  if (tmp$2 !== undefined) {
    tmp.applePayLaterAvailability = Caml_option.valFromOption(tmp$2);
  }
  if (recurring !== undefined) {
    tmp.recurringPaymentRequest = Caml_option.valFromOption(recurring);
  }
  if (deferred !== undefined) {
    tmp.deferredPaymentRequest = Caml_option.valFromOption(deferred);
  }
  if (autoReload !== undefined) {
    tmp.automaticReloadPaymentRequest = Caml_option.valFromOption(autoReload);
  }
  var tmp$3 = requiredBilling.length === 0 ? undefined : requiredBilling;
  if (tmp$3 !== undefined) {
    tmp.requiredBillingContactFields = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = requiredShipping.length === 0 ? undefined : requiredShipping;
  if (tmp$4 !== undefined) {
    tmp.requiredShippingContactFields = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = supportedCountries.length === 0 ? undefined : supportedCountries;
  if (tmp$5 !== undefined) {
    tmp.supportedCountries = Caml_option.valFromOption(tmp$5);
  }
  return tmp;
}

function billingContactItemToObjMapper(dict) {
  return {
          addressLines: Utils$OrcaPaymentPage.getStrArray(dict, "addressLines"),
          administrativeArea: Utils$OrcaPaymentPage.getString(dict, "administrativeArea", ""),
          countryCode: Utils$OrcaPaymentPage.getString(dict, "countryCode", ""),
          familyName: Utils$OrcaPaymentPage.getString(dict, "familyName", ""),
          givenName: Utils$OrcaPaymentPage.getString(dict, "givenName", ""),
          locality: Utils$OrcaPaymentPage.getString(dict, "locality", ""),
          postalCode: Utils$OrcaPaymentPage.getString(dict, "postalCode", "")
        };
}

function shippingContactItemToObjMapper(dict) {
  return {
          emailAddress: Utils$OrcaPaymentPage.getString(dict, "emailAddress", ""),
          phoneNumber: Utils$OrcaPaymentPage.getString(dict, "phoneNumber", ""),
          addressLines: Utils$OrcaPaymentPage.getStrArray(dict, "addressLines"),
          administrativeArea: Utils$OrcaPaymentPage.getString(dict, "administrativeArea", ""),
          countryCode: Utils$OrcaPaymentPage.getString(dict, "countryCode", ""),
          familyName: Utils$OrcaPaymentPage.getString(dict, "familyName", ""),
          givenName: Utils$OrcaPaymentPage.getString(dict, "givenName", ""),
          locality: Utils$OrcaPaymentPage.getString(dict, "locality", ""),
          postalCode: Utils$OrcaPaymentPage.getString(dict, "postalCode", "")
        };
}

function getPaymentRequestFromSession(sessionObj, componentName) {
  var paymentRequest = Utils$OrcaPaymentPage.transformKeys(Core__Option.getOr(Core__Option.getOr(Core__Option.flatMap(sessionObj, Core__JSON.Decode.object), {})["payment_request_data"], {}), "CamelCase");
  var requiredShippingContactFields = Utils$OrcaPaymentPage.getStrArray(Utils$OrcaPaymentPage.getDictFromJson(paymentRequest), "requiredShippingContactFields");
  if (!Utils$OrcaPaymentPage.getIsExpressCheckoutComponent(componentName) && requiredShippingContactFields.length !== 0) {
    var shippingFieldsWithoutPostalAddress = requiredShippingContactFields.filter(function (item) {
          return item !== "postalAddress";
        });
    Utils$OrcaPaymentPage.getDictFromJson(paymentRequest)["requiredShippingContactFields"] = Utils$OrcaPaymentPage.getArrofJsonString(shippingFieldsWithoutPostalAddress);
  }
  return paymentRequest;
}

export {
  defaultHeadlessApplePayToken ,
  getTotal ,
  jsonToPaymentRequestDataType ,
  billingContactItemToObjMapper ,
  shippingContactItemToObjMapper ,
  getPaymentRequestFromSession ,
}
/* Utils-OrcaPaymentPage Not a pure module */
